import { useEffect, useRef, useState } from 'react';
import PlayIconModules from '../../../assets/icons/playIconModules';
import PlayVideoIconSquare from '../../../assets/icons/PlayVideoIconSquare';
import Modal from '../Modal';
import styles from './index.module.scss'
import { Typography } from '@stardust-ds/react';
import intl from 'react-intl-universal';
import useDataApi from '../../../hooks/useDataApi';
import { fnIncrementVideoView, fnTutorialVideosList } from '../../../services/tutorialVideos';
import { useLoaderData, useLocation, useNavigate, useParams, } from 'react-router-dom';
import RcmpLoading from "../../atoms/Loading";
import NoVideos from '../../../assets/img/no-tutorials-video.svg';

function RcmpModalVideosList(props) {
    const { bIsOpen, fnOnClose, oListVideosRes, fnIncrementView, fnSetBIsCouintedVideoPlayer, bIsCouintedVideoPlayer } = props;
    const modalOverflowContent = document.getElementById('modal-overflow-content');
    const modalContentOverflow = document.getElementById('modalOverflowContentContainer');
    if (!bIsOpen) return null;
    if (modalOverflowContent) {
        modalOverflowContent.style.alignItems = 'flex-start';
        modalOverflowContent.style.justifyContent = 'space-between';
        modalOverflowContent.style.paddingBottom = '0';
        modalContentOverflow.style.paddingBottom = '0';

    }


    const [aVideoList, fnSetAVideoList] = useState([]);
    const [oVideoPlayer, fnSetOVideoPlayer] = useState({});
    const videoPlayerConatinerRef = useRef(null);
    const [bIsFirstClick, fnBIsFirstClick] = useState(false)

    useEffect(() => {
        if (!bIsOpen) return;
        if (oListVideosRes.loading === true) return;
        fnSetAVideoList(oListVideosRes?.data?.data)
    }, [oListVideosRes])

    useEffect(() => {
        if (bIsCouintedVideoPlayer && oVideoPlayer && !bIsFirstClick) {
            fnIncrementView(oVideoPlayer.id, true)
            fnSetBIsCouintedVideoPlayer(false)
            fnBIsFirstClick(true)
        }
    }, [bIsCouintedVideoPlayer, bIsFirstClick, oVideoPlayer])

    useEffect(() => {
        if (!bIsOpen || !oVideoPlayer.videoId) return;

        let player;
        const videoId = oVideoPlayer.videoId;

        const loadVideo = () => {
            if (player) {
                // Carrega um novo vídeo sem recriar o player
                player.loadVideoById(videoId);
            } else {
                // Inicializa o player pela primeira vez
                player = new window.YT.Player(videoPlayerConatinerRef.current, {
                    videoId,
                    events: {
                        onStateChange: onPlayerStateChange,
                    },
                });
            }
        };

        const onPlayerStateChange = (event) => {
            if (event.data === window.YT.PlayerState.PLAYING) {
                fnSetBIsCouintedVideoPlayer(true)
            }
        };

        if (!window.YT || !window.YT.Player) {
            // Carrega a API apenas uma vez
            const script = document.createElement('script');
            script.src = 'https://www.youtube.com/iframe_api';
            script.async = true;
            script.onload = () => {
                window.onYouTubeIframeAPIReady = loadVideo;
            };
            document.body.appendChild(script);
        } else {
            loadVideo(); // Se a API já estiver carregada, apenas carrega o vídeo
        }

        return () => {
            if (player) {
                player.destroy(); // Limpa o player ao desmontar
            }
        };
    }, [bIsOpen, oVideoPlayer.videoId]);


    function fnHandleVideoTutorial(oData) {
        const oDataFormated = {
            videoId: oData.vt_clink.split("watch?v=")[1],
            title: oData.vt_ctitle,
            id: oData.vt_nid
        }
        fnBIsFirstClick(false)

        fnSetOVideoPlayer(prev => {
            if (!prev) {
                return oDataFormated
            }
            if (prev.id === oData.vt_nid) {
                return prev
            }
            if (prev.id !== oDataFormated.id) {
                const playerElement = document.getElementById('video-player');
                playerElement.innerHTML = ''; // Remove the existing iframe
                return oDataFormated
            }
        })
    }

    if (oListVideosRes.loading) {
        return (
            <Modal isOpen={true} customWidth={"1130px"} size={null}>
                <Modal.Header onClose={fnOnClose} className={styles.modalHeader}>
                    {intl.get("modal_videos_tutorials.title")}
                </Modal.Header>
                <Modal.Content className={styles.modalContainer}>
                    <div className={styles.modalContent}>
                        <div className={styles.loadingArea}>
                            <RcmpLoading bShow={true} size={50} />
                        </div>
                    </div>
                </Modal.Content>
            </Modal>
        )
    }

    return (
        <Modal isOpen={bIsOpen} customWidth={"1130px"} size={null}>
            <Modal.Header onClose={fnOnClose} className={styles.modalHeader}>
                {intl.get("modal_videos_tutorials.title")}
            </Modal.Header>
            <Modal.Content className={styles.modalContainer}>
                <div className={styles.modalContent}>
                    {oListVideosRes.loading && (
                        <div className={styles.loadingArea}>
                            <RcmpLoading bShow={oListVideosRes.loading} size={50} />
                        </div>
                    )}
                    {
                        !aVideoList?.length ? (
                            <div className={styles.noVideos}>

                                <img src={NoVideos} />
                                <span>Por enquanto não há nenhum vídeo por aqui, mas logo terá. Fique de olho!</span>
                            </div>
                        ) : (
                            <>
                                <div className={styles.leftSide}>

                                    <ul className={styles.videosList}>
                                        <li className={styles.videoItem}>
                                            <div className={styles.videosListButtons}>
                                                {aVideoList.map((oVideo, index) => (

                                                    <div className={oVideo.vt_nid === oVideoPlayer.id ? styles.videoButtomSelected : styles.videoButtom} key={index} onClick={() => fnHandleVideoTutorial(oVideo)}>
                                                        <div>
                                                            <PlayVideoIconSquare className={styles.videoButtomIcon} color={oVideo.vt_nid === oVideoPlayer.id && "#FFFFFF"} />
                                                        </div>
                                                        <span>{oVideo.vt_ctitle}</span>
                                                    </div>
                                                ))}


                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div className={styles.rightSide}  >
                                    <div className={styles.videoPlayer} id='video-player' ref={videoPlayerConatinerRef} />
                                    <span>{oVideoPlayer?.title}</span>
                                </div>
                            </>
                        )
                    }

                </div>
            </Modal.Content>
        </Modal>
    );
}


export default function RcmpModalVideosTutorials(props) {
    const { className } = props
    const [bOpenVideoPlayer, setBOpenVideoPlayer] = useState(false);
    const [oListVideosRes, setOListVideosReq] = useDataApi(fnTutorialVideosList);
    const [oIncrementVideoViewRes, setOIncrementVideoViewReq] = useDataApi(fnIncrementVideoView);
    const [aVideoList, fnSetAVideoList] = useState([]);
    const [bIsCouintedVideoPlayer, fnSetBIsCouintedVideoPlayer] = useState(false);
    const { pathname } = useLocation()
    const aModules = {
        "/": "2",
        "/ciq": "5",
        "/ciq/sigma": "5",
    }


    function fnHandleOpenVideoPlayer() {
        setBOpenVideoPlayer(true);
    }
    function fnHandleCloseVideoPlayer() {
        setBOpenVideoPlayer(false);
    }
    useEffect(() => {
        if (!bOpenVideoPlayer) return;
        (async () => {
            fnSetBIsCouintedVideoPlayer(false)
            const response = await setOListVideosReq(aModules[pathname]);
            if (response.data.success) {
                fnSetAVideoList(response.data.data)
            }
        })();

    }, [bOpenVideoPlayer])


    async function fnIncrementView(nId, bCanCount) {
        if (bCanCount) {
            const response = await setOIncrementVideoViewReq(nId)
            return response
        }
        return
    }
    const cClass = className ? `${styles.modalVideosTutorials} ${className}` : styles.modalVideosTutorials;
    return (
        <div className={cClass} onClick={() => fnHandleOpenVideoPlayer()}>
            <PlayIconModules

            />
            {bOpenVideoPlayer && (
                <RcmpModalVideosList bIsOpen={bOpenVideoPlayer} fnOnClose={fnHandleCloseVideoPlayer} oListVideosRes={oListVideosRes} fnIncrementView={fnIncrementView} aVideoList={aVideoList} bIsCouintedVideoPlayer={bIsCouintedVideoPlayer} fnSetBIsCouintedVideoPlayer={fnSetBIsCouintedVideoPlayer} />
            )}
        </div>
    )
}